import { useLayoutEffect, useEffect } from 'react';

const isBrowser =
  typeof window !== 'undefined' &&
  typeof document?.createElement === 'function';
const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
